export enum IRONCLAD_CONTRACT_EVENTS {
  ACCEPTANCE_SENT = 'contract_acceptance_sent',
  ACCEPTANCE_FAILED = 'contract_acceptance_failed',
}

export enum ACCEPTANCE_SOURCE {
  GENERAL = 'General',
}
